export const ErrorCode = {
    '420': 'Card Already Exists',
};
